import { routes } from '$src/routes';
import { history } from '$src/stores/history';
import { generatePath } from 'react-router-dom';
import {
  emergencyContacts,
  professionalMonitoring,
  enableProfessionalMonitoring,
  professionalMonitoringSettings,
  exitPracticeMode,
  monitoredZonesWeb,
  monitoredZonesApp,
} from '$src/utils/RapidSolutionsIntegrations/urls';
import isWebView, { isMobileDevice } from '$src/utils/user-agent';
import { navigateToRingApp } from '$src/utils/navigateToRingApp';

export const redirectToFreeTrial = (locationId) => {
  history.push(generatePath(routes.freeTrial, { locationId }));
};

export const redirectToSettings = (locationId, search) => {
  history.push({ pathname: generatePath(routes.settings, { locationId }), search });
};

export const redirectToDeviceAuthorization = (locationId, state) => {
  history.push({ pathname: generatePath(routes.devices, { locationId }), state });
};

export const redirectToLocations = () => {
  history.push(routes.locations);
};

export const redirectToDashboard = (replaceStack) => {
  if (replaceStack) {
    history.replace(routes.dashboard);
  }
  else {
    history.push(routes.dashboard);
  }
};

export const redirectToUpsell = () => {
  history.push(routes.upsell)
};

/**
 * Smart routing for watch zones (aka monitoring zones) based on device type
 * @param {string} locationId - The Ring location ID
 * @returns {boolean} - Returns true if redirect happened, false if modal should be shown
 */
export const redirectToWatchZones = (locationId) => {
  if (isMobileDevice()) {
    // Mobile WebView (in app) and mobile browsers -> show modal
    return false;
  }
  // Desktop/tablet browsers -> web page
  window.location.assign(monitoredZonesWeb(locationId));
  return true;
};

/**
 * Opens watch zones in the Ring app
 * @param {string} locationId - The Ring location ID
 */
export const redirectToWatchZonesInRingApp = (locationId) => {
  if (isWebView()) {
    // Mobile WebView (in app) -> native bridge
    navigateToRingApp(monitoredZonesApp(locationId));
    return;
  }
  // Mobile browsers -> universal link, which the Ring app opens (or ring.com sends to the app store)
  window.location.assign(monitoredZonesApp(locationId));
};

// onboarding
export const redirectToOnboardingDeviceAuthorization = (locationId) => {
  history.push(generatePath(`${routes.onboardingDevices}`, { locationId }));
};

export const redirectToOnboardingProfessionalMonitoring = (locationId, state) => {
  history.push({ pathname: generatePath(`${routes.onboardingProfessionalMonitoring}`, { locationId }), state });
};

export const redirectToOnboardingSOSTurnOn = (locationId) => {
  history.push(generatePath(`${routes.onboardingSOSTurnOn}`, { locationId }));
};

export const redirectToOnboardingSOSSetUp = (locationId) => {
  history.push(generatePath(`${routes.onboardingSOSSetUp}`, { locationId }));
};

export const redirectToOnboardingIntroduction = (locationId, state) => {
  history.push({ pathname: generatePath(`${routes.onboardingIntroduction}`, { locationId }), state });
};

export const redirectToOnboardingEmergencyContacts = (locationId, state) => {
  history.push({ pathname: generatePath(`${routes.onboardingEmergencyContacts}`, { locationId }), state });
};

export const redirectToOnboardingAlertPreferences = (locationId) => {
  history.push(generatePath(`${routes.onboardingAlertPreferences}`, { locationId }));
};

export const redirectToOnboardingSetupComplete = (locationId) => {
  history.push(generatePath(`${routes.onboardingSetupComplete}`, { locationId }));
};

export const redirectToOnboardingHowVSGWorks = (locationId) => {
  history.push(generatePath(`${routes.onboardingHowVSGWorks}`, { locationId }));
};

export const redirectToOnboardingEventsAndPrivacy = (locationId) => {
  history.push(generatePath(`${routes.onboardingEventsAndPrivacy}`, { locationId }));
};

export const redirectToPracticeMode = (locationId) => {
  history.push(generatePath(`${routes.onboardingPracticeMode}`, { locationId }));
};

export const redirectToOnboardingDenied = (locationId) => {
  history.push({
    pathname: routes.onboard,
    search: `error_code=onboarding_denied&locationId=${locationId}`,
  });
};

export const redirectToOnboardingError = (locationId) => {
  history.push(generatePath(`${routes.onboardingError}`, { locationId }));
};

// RingSolutions

export const redirectToOnboardingRingSolutionsProfessionalMonitoring = (locationId) => {
  window.location.assign(professionalMonitoring(locationId));
};

export const redirectToOnboardingRingSolutionsEmergencyContacts = (locationId) => {
  window.location.assign(professionalMonitoring(locationId));
};

export const redirectToEnableProfessionalMonitoring = (locationId) => {
  window.location.replace(enableProfessionalMonitoring(locationId));
};

export const redirectToExitPracticeMode = (locationId) => {
  window.location.replace(exitPracticeMode(locationId));
};

export const redirectToEmergencyContacts = (locationId) => {
  window.location.assign(emergencyContacts(locationId));
};

export const redirectToProfessionalMonitoringSettings = (locationId) => {
  window.location.assign(professionalMonitoringSettings(locationId));
};

// General url
export const redirectToURL = (url) => {
  window.location.assign(url);
};
